<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity Start (first line in a block)              -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row dense class="DutyActivityStart_Default">
    <v-col cols="1">
      <time-line-point :small="true" :cellHeight="30" :themeName="themeName" :topConnection="false" :bottomConnection="true"></time-line-point>
    </v-col>
    <v-col cols="8"> {{ dutyActivity.id }} {{ dutyStopsById[dutyActivity.startStopIdFk].longname }} &nbsp;{{ dutyActivity.note }} </v-col>
    <v-col cols="3">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityStartDefault',
  components: {
    TimeLinePoint,
  },
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
